import logo from 'Assets/Images/Tria Logo_Primary_With Tag.png'
import { registerRalewayFont } from 'Fonts/RalewayFont'
import { theme } from 'Styles/styledTheme'
import dayjs from 'dayjs'
import jsPDF from 'jspdf'
import { DashboardState } from 'reducers/dashboardSlice'
import { ReadingCounts } from 'types/Dashboards'

export const generateCGMPDF = (startDate, endDate, readingCounts: ReadingCounts, glucoseReadingsSummary: DashboardState, pieChartImage) => {
  const doc = new jsPDF('p', 'mm', 'letter')
  registerRalewayFont(doc)
  const dateRange = `${dayjs(startDate).format('MMMM DD, YYYY')} - ${dayjs(endDate).format('MMMM DD, YYYY')}`
  const veryHighPercent = Math.round((readingCounts.high / readingCounts.total) * 1000) / 10
  const highPercent = Math.round((readingCounts.aboveRange / readingCounts.total) * 1000) / 10
  const inRangePercent = Math.round((readingCounts.inRange / readingCounts.total) * 1000) / 10
  const lowPercent = Math.round((readingCounts.low / readingCounts.total) * 1000) / 10
  const veryLowPercent = Math.round((readingCounts.criticalLow / readingCounts.total) * 1000) / 10
  const gmi = glucoseReadingsSummary.glucoseManagementIndicator
  const gvi = glucoseReadingsSummary.glucoseVariability
  const average = glucoseReadingsSummary.averageCGMReading
  const lowBreakdown = Math.round(((readingCounts.low + readingCounts.criticalLow) / readingCounts.total) * 1000) / 10
  const highBreakdown = Math.round(((readingCounts.aboveRange + readingCounts.high) / readingCounts.total) * 1000) / 10
  const dexcomImage = 'https://triacentral.blob.core.windows.net/dev-storage/logos/dexcom/dexcom_logo.png'

  //Date box
  doc.setDrawColor(theme.colors.lightGray)
  doc.roundedRect(5, -10, 125, 30, 5, 5)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(15)
  doc.setTextColor(theme.colors.primary1)
  doc.text(`${dateRange}`, 67.5, 12.5, { align: 'center' })
  //Logo
  doc.addImage(logo, 'JPEG', 133, 0, 80, 27.5)
  //Data Provider Logo
  doc.addImage(dexcomImage, 'JPEG', 15, 25, 65, 5)
  //Graph and Key Box
  doc.roundedRect(7.5, 35, 200, 100, 5, 5)
  doc.addImage(pieChartImage, 'JPEG', 8.5, 40, 85, 85)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(15)
  doc.setTextColor('black')
  doc.text(`${readingCounts.high}`, 97.5, 50)
  doc.text(`(${veryHighPercent}%)`, 130, 50, { align: 'right' })
  doc.setDrawColor(theme.colors.charts.dangerousHigh)
  doc.setFillColor(theme.colors.charts.dangerousHigh)
  doc.roundedRect(132.5, 45, 6, 6, 1, 1, 'F')
  doc.text('Very High:', 140.5, 50)
  doc.text(`${readingCounts.aboveRange}`, 97.5, 67.5)
  doc.text(`(${highPercent}%)`, 130, 67.5, { align: 'right' })
  doc.setDrawColor(theme.colors.charts.high)
  doc.setFillColor(theme.colors.charts.high)
  doc.roundedRect(132.5, 62.5, 6, 6, 1, 1, 'F')
  doc.text('High:', 140.5, 67.5)
  doc.text(`${readingCounts.inRange}`, 97.5, 85)
  doc.text(`(${inRangePercent}%)`, 130, 85, { align: 'right' })
  doc.setDrawColor(theme.colors.charts.inRange)
  doc.setFillColor(theme.colors.charts.inRange)
  doc.roundedRect(132.5, 80, 6, 6, 1, 1, 'F')
  doc.text('In Range:', 140.5, 85)
  doc.text(`${readingCounts.low}`, 97.5, 102.5)
  doc.text(`(${lowPercent}%)`, 130, 102.5, { align: 'right' })
  doc.setDrawColor(theme.colors.charts.low)
  doc.setFillColor(theme.colors.charts.low)
  doc.roundedRect(132.5, 97.5, 6, 6, 1, 1, 'F')
  doc.text('Low:', 140.5, 102.5)
  doc.text(`${readingCounts.criticalLow}`, 97.5, 120)
  doc.text(`(${veryLowPercent}%)`, 130, 120, { align: 'right' })
  doc.setDrawColor(theme.colors.charts.dangerousLow)
  doc.setFillColor(theme.colors.charts.dangerousLow)
  doc.roundedRect(132.5, 115, 6, 6, 1, 1, 'F')
  doc.text('Very Low:', 140.5, 120)
  doc.setFont('Raleway', 'Regular')
  doc.setFontSize(15)
  doc.setTextColor('black')
  doc.text('>250 mg/dL', 167.5, 50)
  doc.text('>180 mg/dL', 154.5, 67.5)
  doc.text('70-180 mg/dL', 164.5, 85)
  doc.text('<70 mg/dL', 153.5, 102.5)
  doc.text('<54 mg/dL', 166.5, 120)
  doc.setDrawColor(theme.colors.lightGray)
  doc.line(92.5, 56.25, 202.5, 56.25)
  doc.line(92.5, 73.75, 202.5, 73.75)
  doc.line(92.5, 91.25, 202.5, 91.25)
  doc.line(92.5, 108.75, 202.5, 108.75)
  //Glucose Management Indicator Box
  doc.roundedRect(7.5, 140, 97.5, 65, 5, 5)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(15)
  doc.setTextColor('black')
  doc.text('Glucose\nManagement\nIndicator (GMI)', 17.5, 155)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(36)
  doc.setTextColor(theme.colors.primary1)
  doc.text(`${gmi}%`, 97.5, 162.5, { align: 'right' })
  doc.line(12.5, 172.5, 100, 172.5)
  doc.setFont('Raleway', 'Regular')
  doc.setFontSize(12)
  doc.setTextColor('black')
  doc.text('GMI is calculated using\nthe formula GMI (%) =\n3.31 + 0.02392 x mean\nglucose in mg/dL', 17.5, 180)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(15)
  doc.setTextColor('black')
  doc.text('Goal: <7%', 97.5, 185, { align: 'right' })
  //Breakdown Box
  doc.roundedRect(110, 140, 97.5, 65, 5, 5)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(12)
  doc.setTextColor('black')
  doc.text('Average:', 120, 152.5)
  doc.setFont('Raleway', 'Regular')
  doc.setFontSize(15)
  doc.setTextColor('black')
  doc.text(`${average} mg/dL`, 197.5, 152.5, { align: 'right' })
  doc.line(115, 157.5, 200, 157.5)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(12)
  doc.setTextColor('black')
  doc.text('Low (<70 mg/dL):', 120, 167.5)
  doc.setFont('Raleway', 'Regular')
  doc.setFontSize(15)
  doc.setTextColor('black')
  doc.text(`${lowBreakdown}%`, 197.5, 167.5, { align: 'right' })
  doc.line(115, 172.5, 200, 172.5)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(12)
  doc.setTextColor('black')
  doc.text('In Range (70 - 180 mg/dL):', 120, 182.5)
  doc.setFont('Raleway', 'Regular')
  doc.setFontSize(15)
  doc.setTextColor('black')
  doc.text(`${inRangePercent}%`, 197.5, 182.5, { align: 'right' })
  doc.line(115, 187.5, 200, 187.5)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(12)
  doc.setTextColor('black')
  doc.text('High (>180 mg/dL):', 120, 197.5)
  doc.setFont('Raleway', 'Regular')
  doc.setFontSize(15)
  doc.setTextColor('black')
  doc.text(`${highBreakdown}%`, 197.5, 197.5, { align: 'right' })
  //Glucose Variability Indicator Box
  doc.roundedRect(7.5, 210, 97.5, 65, 5, 5)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(15)
  doc.setTextColor('black')
  doc.text('Glucose\nVariability\nIndicator (GVI)', 15, 225)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(36)
  doc.setTextColor(theme.colors.primary1)
  doc.text(`${gvi}%`, 97.5, 232.5, { align: 'right' })
  doc.line(12.5, 242.5, 100, 242.5)
  doc.setFont('Raleway', 'Regular')
  doc.setFontSize(12)
  doc.setTextColor('black')
  doc.text('The measurement\nof deviation from\nthe steady glucose\nstate', 17.5, 250)
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(15)
  doc.setTextColor('black')
  doc.text('Goal: <36%', 97.5, 255, { align: 'right' })
  //Contact Portion
  doc.setFont('Raleway', 'Bold')
  doc.setFontSize(15)
  doc.setTextColor('black')
  doc.text('Have questions about the\ninformation above or would\nlike more detail?', 120, 225)
  doc.setFont('Raleway', 'Regular')
  doc.setFontSize(12)
  doc.setTextColor('black')
  doc.text('Call a Tria Health pharmacist at\n1-888-799-8742 or message us\nanytime through your patient portal.', 120, 250)

  doc.save(`Glucose Summary: ${dateRange}.pdf`)
}
